<ng-content></ng-content>

<div class="menu-container">
  <dx-tree-view
    id="side-tree-menu"
    [items]="items"
    keyExpr="path"
    selectionMode="single"
    [focusStateEnabled]="false"
    expandEvent="click"
    width="100%"
    itemTemplate="my-item"
    class="custom-tree-view">
    <div *dxTemplate="let item of 'my-item'" class="menu-item-wrap">
      <a
        class="menu-link"
        [routerLink]="[item.path]"
        [attr.href]="item.path"
        rel="noopener"
      >
        <i class="dx-icon dx-icon-{{item.icon}} menu-icon"></i>
        <span class="menu-text">{{ item.text }}</span>
      </a>
    </div>
  </dx-tree-view>
</div>
